var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSolution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6666 15.0879C3.6666 15.3101 3.84698 15.4905 4.06924 15.4905H9.70432C9.92658 15.4905 10.107 15.3101 10.107 15.0879V12.146C11.7994 11.0769 12.9247 9.18903 12.9247 7.03771C12.9243 3.70301 10.2209 1 6.88659 1C3.55226 1 0.848877 3.70301 0.848877 7.03771C0.848877 9.18903 1.97416 11.0769 3.6666 12.146V15.0879ZM4.4715 14.6852V11.9188C4.4715 11.7751 4.3949 11.6422 4.27037 11.5705C2.7051 10.6652 1.65378 8.97393 1.65378 7.03771C1.65378 4.14791 3.99679 1.8049 6.88659 1.8049C9.77639 1.8049 12.1194 4.14754 12.1194 7.03771C12.1194 8.97393 11.0677 10.6652 9.50281 11.5705C9.37828 11.6426 9.30205 11.7754 9.30205 11.9188V14.6852H4.4715Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1065 17.9056H3.66656V17.1007H10.1065V17.9056Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3915 5.71248L6.36622 9.73774C6.20886 9.89472 5.95415 9.89472 5.79717 9.73774L3.38208 7.32266L3.95151 6.7536L6.08207 8.88416L9.82281 5.1438L10.3915 5.71248Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolution);
export default __webpack_public_path__ + "static/media/CheckSolution.435b93cb77eeb27425ee238ce30c5c9e.svg";
export { ForwardRef as ReactComponent };